import { contentManagementRoutesObj } from "./path";

import type { IRouteMetadataObj } from "@routes/types";
import { createRoute } from "@/routes/utils";
import { IRoleEnum } from "@/interfaces";

const permission = [
  IRoleEnum.SUPER_ADMIN,
  IRoleEnum.Teacher,
  IRoleEnum.ASSISTANT,
];

const contentManagementRouteMetadata: IRouteMetadataObj<
  typeof contentManagementRoutesObj
> = {
  list: {
    title: "contentManagement.index.title",
    description: "contentManagement.index.description",
    lazy: () => import("@/pages/contentManagement/table/page"),
    mode: "index",
    type: "main",
    icon: "Slideshow4Line",
    breadcrumbs: [],
    permission,
  },
  create: {
    title: "contentManagement.create.title",
    description: "contentManagement.create.description",
    lazy: () => import("@/pages/contentManagement/form/page"),
    mode: "create",
    type: "inner",
    icon: "AddLine",
    breadcrumbs: [],
    permission,
  },
  edit: {
    title: "contentManagement.edit.title",
    description: "contentManagement.edit.description",
    lazy: () => import("@/pages/contentManagement/form/page"),
    mode: "edit",
    type: "inner",
    icon: "EditLine",
    breadcrumbs: [],
    permission,
  },
  view: {
    title: "contentManagement.view.title",
    description: "contentManagement.view.description",
    lazy: () => import("@/pages/contentManagement/view/page"),
    mode: "edit",
    type: "inner",
    icon: "GraduationCapLine",
    breadcrumbs: [],
    permission,
  },
};

export const contentManagementRoutes = createRoute<
  typeof contentManagementRoutesObj
>(contentManagementRoutesObj, contentManagementRouteMetadata);
